import React from 'react';
import { apiHolder as api, apis } from 'api';
import styles from './UnfinishedDrafts.module.scss';
import IconCard from '@web-common/components/UI/IconCard';
import useState2RM from '@web-mail/hooks/useState2ReduxMock';
import SiriusModal from '@web-common/components/UI/Modal/SiriusModal';
import { formatTimeWithHM } from '@web-mail/util';
import { formatTime } from '@web-mail/util';
import SiriusMessage from '@web-common/components/UI/Message/SiriusMessage';
import { AlertErrorIcon } from '@web-common/components/UI/Icons/icons';
import { defaultComSummary, defaultDescFun, defaultSender } from '@web-mail/common/components/vlistCards/MailCard/defaultComs';
import { getIn18Text } from 'api';
const mailDraftApi = api.api.requireLogicalApi(apis.mailDraftApiImpl);
const Sender = defaultSender;
const ComSummary = defaultComSummary;
export const UnfinishedDrafts = ({ draftMailArr, getAllDraftMail, delDraftMailByIndex, close }) => {
    const [showConcreteTime] = useState2RM('configMailListShowConcreteTime');
    const recoverVersion = async (draft) => {
        await mailDraftApi.recoverDraft(draft);
        close();
    };
    const clearAll = async () => {
        SiriusModal.confirm({
            title: getIn18Text('SHIFOUQINGKONGQUNBUWEIBAOCUN'),
            icon: React.createElement(AlertErrorIcon, null),
            content: '',
            okType: 'primary',
            okText: getIn18Text('QINGKONG'),
            onOk: () => clearAllAction(),
        });
    };
    const clearAllAction = async () => {
        try {
            const clearRes = await mailDraftApi.clearDraftMail();
            const { success, message } = clearRes;
            if (success) {
                SiriusMessage.success({ content: getIn18Text('YISHANCHU') });
                getAllDraftMail();
                close();
                return;
            }
            SiriusMessage.error({ content: message });
        }
        catch (error) {
            console.log('清空草稿邮件失败', error);
            SiriusMessage.error({ content: '清空草稿邮件失败' });
        }
    };
    const delVersionBatch = async (versions, index) => {
        const curCid = versions[0].cid;
        if (curCid) {
            try {
                const delRes = await mailDraftApi.deleteDraftMailByCid(curCid);
                const { success, message } = delRes;
                if (success) {
                    delDraftMailByIndex(index);
                }
                else {
                    SiriusMessage.error({ content: message });
                }
            }
            catch (error) {
                console.log('删除草稿邮件失败', error);
                SiriusMessage.error({ content: '删除草稿邮件失败' });
            }
        }
    };
    const versionTime = (version) => {
        const { createTime } = version;
        if (!createTime)
            return '';
        return showConcreteTime ? formatTimeWithHM(createTime) : formatTime(createTime);
    };
    return (React.createElement("div", { className: styles.unfinishedDrafts },
        React.createElement("div", { className: styles.header },
            React.createElement("div", { className: styles.headerTop }, getIn18Text('WEIBAOCUNCAOGAOLIEBIAO')),
            React.createElement("div", { className: styles.headerBottom }, (draftMailArr === null || draftMailArr === void 0 ? void 0 : draftMailArr.length) ? (React.createElement("div", { className: styles.clearAll, onClick: clearAll },
                React.createElement(IconCard, { className: styles.brush, type: "brush" }),
                React.createElement(IconCard, { className: styles.brushBlue, type: "brush", stroke: "#4C6AFF" }),
                React.createElement("span", { style: { paddingLeft: '4px' } }, getIn18Text('QINGKONGQUANBU')))) : (React.createElement(React.Fragment, null)))),
        (draftMailArr === null || draftMailArr === void 0 ? void 0 : draftMailArr.length) ? (React.createElement("div", { className: styles.versionBatchList }, draftMailArr.map(({ versions, cid }, index) => {
            var _a;
            return (React.createElement("div", { className: styles.versionBatch, key: cid },
                React.createElement("div", { className: styles.timeLine }),
                versions && versions[0] && (React.createElement("div", { className: styles.recentVersion, key: versions[0].draftVersionId },
                    React.createElement("div", { className: styles.circle }),
                    React.createElement("div", { className: styles.versionTitle }, getIn18Text('ZUIJINBANBEN')),
                    React.createElement("div", { className: styles.recentVersionDetail },
                        React.createElement("div", { className: styles.recentVersionTop },
                            React.createElement("div", { className: styles.to }, ((_a = versions[0].receiver) === null || _a === void 0 ? void 0 : _a.length) ? React.createElement(Sender, { data: versions[0], extraData: 'localDraft' }) : getIn18Text('WUSHOUJIANREN')),
                            React.createElement("div", { className: styles.right },
                                React.createElement("div", { className: styles.versionTime }, versionTime(versions[0])),
                                React.createElement("div", { className: styles.recover, onClick: () => recoverVersion(versions[0]) }, getIn18Text('HUIFU11')))),
                        React.createElement("div", { className: styles.recentVersionTheme },
                            React.createElement(ComSummary, { data: versions[0] })),
                        React.createElement("div", { className: styles.recentVersionContent }, defaultDescFun({ data: versions[0] }, true))))),
                versions && (versions === null || versions === void 0 ? void 0 : versions.length) > 1 && (React.createElement("div", { className: styles.historyVersions },
                    React.createElement("div", { className: styles.circle }),
                    React.createElement("div", { className: styles.versionTitle }, getIn18Text('LISHIBANBEN')),
                    versions.map((otherVersion, hisIndex) => {
                        return hisIndex > 0 ? (React.createElement("div", { className: styles.historyVersionItem, key: otherVersion.draftVersionId },
                            React.createElement("div", { className: styles.versionName },
                                getIn18Text('LISHIBANBEN'),
                                hisIndex),
                            React.createElement("div", { className: styles.right },
                                React.createElement("div", { className: styles.versionTime }, versionTime(otherVersion)),
                                React.createElement("div", { className: styles.recover, onClick: () => recoverVersion(otherVersion) }, getIn18Text('HUIFU11'))))) : (React.createElement("div", { key: otherVersion.draftVersionId, style: { display: 'none' } }));
                    }))),
                React.createElement("div", { className: styles.versionBatchFooter },
                    React.createElement("div", { className: styles.delArea, onClick: () => delVersionBatch(versions, index) },
                        React.createElement(IconCard, { className: `dark-invert ${styles.recycleBin}`, type: "recycleBin" }),
                        React.createElement(IconCard, { className: styles.recycleBinBlue, type: "recycleBin", stroke: "#4C6AFF" }),
                        React.createElement("span", { style: { paddingLeft: '3px' } }, getIn18Text('SHANCHU'))))));
        }))) : (React.createElement("div", { className: styles.noDataArea },
            React.createElement("div", { className: "sirius-empty sirius-empty-doc", style: { margin: '0 auto' } }),
            React.createElement("p", { className: styles.noDataText },
                getIn18Text('ZANWUSHUJU'),
                " ")))));
};
